import { createContext, useContext } from "react"

export const OpenGalleryContext = createContext()

export const useOpenGallery = () => useContext(OpenGalleryContext)
